import apiUrlConfig from 'configs/apiUrlConfig';
import AuthenticatedRequestService from 'services/requests/Authenticated';

const URLS = {
  RESET: `${apiUrlConfig.endPoint()}/users/password`,
  UPDATE: `${apiUrlConfig.endPoint()}/users/password`,
};

class PasswordApi {
  /**
   * send reset password email
   */
  static reset(email) {
    const data = {
      user: {
        email,
      },
    };

    return AuthenticatedRequestService.post(URLS.RESET, data);
  }

  /**
   * send reset password email
   */
  static update(newPassword, resetToken) {
    const data = {
      user: {
        password: newPassword,
        password_confirmation: newPassword,
        reset_password_token: resetToken,
      },
    };

    return AuthenticatedRequestService.patch(URLS.RESET, data);
  }
}

export default PasswordApi;



// WEBPACK FOOTER //
// ./src/apis/Password.js